var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-container',{staticClass:"hello",attrs:{"max-width":'100%'}},[_c('vessel-admin-wrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }